import { APIError, useAPIRequest } from "@certn/legacy-api";
import { useNavigate } from "react-router-dom";

export function usePassCodeCreate() {
  const navigate = useNavigate();
  const request = useAPIRequest();

  return async (email: string) => {
    try {
      await request("/internal/people/auth/verification-code/send/", {
        method: "POST",
        body: JSON.stringify({
          email,
        }),
      });
      navigate(`/auth/check-passcode${location.search}`, {
        state: { userEmail: email },
      });
    } catch (e) {
      if (e instanceof APIError) {
        if (e.errors.type === "info_blocked") {
          navigate(`/auth/welcome${location.search}`, {
            state: {
              errorMessage: e.errors.message,
              errorType: e.errors.type,
            },
          });
        }
      }
    }
  };
}

interface PassCodeVerifyResponseType {
  user_exists: boolean;
  verification_token: string;
}

export function usePassCodeVerify() {
  const navigate = useNavigate();
  const request = useAPIRequest();

  const verify = async (
    onSuccess: (value: string) => void,
    setPassCode: (value: string) => void,
    setIsFail: (value: boolean) => void,
    setIsSuccess: (value: boolean) => void,
    email?: string,
    code?: string
  ) => {
    try {
      const response = await request<PassCodeVerifyResponseType>(
        "/internal/people/auth/verification-code/verify/",
        {
          method: "POST",
          body: JSON.stringify({
            email,
            code,
          }),
        }
      );

      onSuccess(response?.verification_token);
      setIsFail(false);
    } catch (e) {
      setIsFail(true);
      setIsSuccess(false);
      setPassCode("");

      if (e instanceof APIError) {
        if (e.errors.type === "info_blocked") {
          navigate(`/auth/welcome${location.search}`, {
            state: {
              errorMessage: e.errors.message,
              errorType: e.errors.type,
            },
          });
        }
      }
    }
  };
  return { verify };
}
